export type Tab = 'category' | 'target' | 'region'

export const TABS: { key: Tab; label: string }[] = [
  { key: 'category', label: '문제 분야' },
  { key: 'target', label: '주 대상' },
  { key: 'region', label: '지역' },
]
